module.exports = __webpack_public_path__ + "img/EN.09424403.svg";